import React from "react";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { ButtonLink } from "@irati/ui/src/Link";
var DownloadPdf = function (_a) {
    var pdf = _a.pdf, formatMessage = _a.formatMessage;
    if (!pdf)
        return null;
    return (React.createElement(ButtonLink, { primary: true, full: true, href: pdf, target: "_blank", alt: formatMessage({ id: "perks.components.tickets.downloadPdfText" }) },
        React.createElement(Icon, { icon: IconTypes.newTab, marginRight: true }),
        React.createElement(FormattedMessage, { id: "perks.components.tickets.downloadPdfText" })));
};
export default injectIntl(DownloadPdf);
